"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9689],{

/***/ 9689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionCardSlider": function() { return /* binding */ SectionCardSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const SlideWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    gridRow: 1
});
const Text = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06",
    width: "85%",
    gridRow: 2
});
const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    display: "grid",
    rowGap: "$20"
});
const SectionCardSlider = (param)=>{
    let { slides , priority  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSectionWrapper, {
        type: "RICH_TEXT_LG",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Slider */ .iR, {
            children: [
                slides === null || slides === void 0 ? void 0 : slides.map((slide, index)=>{
                    var _slide_media, _slide_media1;
                    return (slide === null || slide === void 0 ? void 0 : (_slide_media = slide.media) === null || _slide_media === void 0 ? void 0 : _slide_media.mediaPayload) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlideWrap, {
                        style: {
                            gridColumn: index + 1
                        },
                        children: slide._type === "simpleMedia" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
                                ...slide.media,
                                priority: priority && index < 3,
                                sizes: "(min-width: 1000px) 486px, 290px"
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MediaWithBackground */ .xu, {
                            media: slide.media,
                            priority: priority && index < 3,
                            mediaBorder: slide.mediaBorder,
                            color: slide.color,
                            sizes: "(min-width: 1000px) 486px, 290px",
                            appearance: "slider"
                        })
                    }, "".concat(slide === null || slide === void 0 ? void 0 : (_slide_media1 = slide.media) === null || _slide_media1 === void 0 ? void 0 : _slide_media1.alt, "-").concat(slide._type, "-").concat(index));
                }),
                slides === null || slides === void 0 ? void 0 : slides.map((slide, index)=>{
                    var _slide_media;
                    return (slide === null || slide === void 0 ? void 0 : (_slide_media = slide.media) === null || _slide_media === void 0 ? void 0 : _slide_media.mediaPayload) && slide.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                        style: {
                            gridColumn: index + 1
                        },
                        children: [
                            "↑ ",
                            slide.text
                        ]
                    }, "".concat(index, "-text"));
                })
            ]
        })
    });
};


/***/ })

}]);